module.exports = __webpack_public_path__ + "img/course_bg4.0e56a33b.png";